import React from 'react';
import { updateSwap } from '@/api/bet/update';
import { UpdateSwapType } from '@/types';
import ExcelUploadBase from './ExcelUploadBase';

/**
 * status가 진행 중에서 더 이상 진행 되지 않는 건을 확인 후
 * 관리자가 수동으로 지급(sfl, point) 후 완료 처리
 * 상태변화만 있고 실제 지급은 하지 않음
 */
export default function ExcelBetSwapUpload() {
  return (
    <ExcelUploadBase<UpdateSwapType>
      dataType="베팅 스왑"
      onUpload={updateSwap}
      otpTitle="베팅 스왑 업로드 인증"
      otpDescription="베팅 스왑 업로드를 위해 OTP 인증이 필요합니다."
    />
  );
}
